import React, { useState,useEffect } from 'react';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { confirmDialog } from 'primereact/confirmdialog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from "primereact/inputswitch";

import appUrl from '../../../../constants/appUrl';
import AddEditProcessInformation from '../components/AddEditProcessInformation';
const ProcessInformation = ({product}) => {
    console.log("Alllllllllllllllllllllll",product)

    const [scheduleData, setScheduleData] = useState([]);
    const [dialog, setDialog] = useState();
    const [checked, setChecked] = useState(false);

    const [productList, setProductList] = useState([]);
    // Sample data for the DataTable
   
    const GetProcessById = async ( productId) => {
        console.log('productId', productId)
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Process/GetProcessByProductId/${productId}`);

            const data = await response.json();
            setProductList(data);
  
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };
  
    useEffect(() => {
        if(product && product.productId) {
            GetProcessById(product.productId);
        }
    }, [product]);

    const renderAttachment = () => {
        return <i className="pi pi-eye"></i>;
    };
    const actionTemplate = (rowData) => {
        return (
            <div>
                <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />

            </div>
        );
    };
    const onHide = () => {
        setDialog(false)
    }
    const addScheduleData = (formData) => {
          {
            setScheduleData([...scheduleData, formData]);
            toast.success("Add Succesfully")
        }
        setDialog(false);
    };


    return (<>
       <ToastContainer />
        <Dialog visible={dialog} onHide={onHide} header={"Add New"} style={{ width: "70vw" }}>
            <AddEditProcessInformation   onSubmit={addScheduleData} />
        </Dialog>

        <div className='grid'>
            <div className="md:col-8"></div>
            <div className='md:col-2'>
                <InputText className="w100" placeholder="Search" />
            </div>

            <div className=" md:col-2" >
                <div >
                    <Button className=" p-button custom-bg w100" label="Add New" onClick={() => {  setDialog(true) }} />
                </div>
            </div>

            <div className='md:col-12' >
                <DataTable
                     value={productList}
                    scrollable
                    scrollHeight="500px"
                    rows={5}
                    paginator
                >
                    {/* <Column field='' header="Sr No" /> */}
                    <Column field='description' header="Description" />
                    <Column field='policyPrefix' header="Prefix" />
                    <Column body={renderAttachment} header="Attachment" />

                    <Column header="Action" body={actionTemplate} />
                </DataTable>
            </div>
        </div>
    </>
    );
};

export default ProcessInformation;
